/* CarPlay Auto — JavaScript minimal (aucune dépendance externe). */
var CPT = window.cpI18n || {};
(function () {
  'use strict';

  /* ---------------------------------------------- En-tête collant */
  var header = document.querySelector('[data-cp-header]');
  if (header && document.body.classList.contains('cp-is-home')) {
    var stuck = false;
    var onScroll = function () {
      var should = window.scrollY > 90;
      if (should !== stuck) {
        stuck = should;
        header.classList.toggle('is-stuck', stuck);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------- Menu mobile (drawer) */
  var burger = document.querySelector('[data-cp-burger]');
  var nav = document.getElementById('cp-nav');
  if (burger && nav) {
    var scrim = null;

    var closeNav = function () {
      nav.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', CPT.menuOpen || 'Ouvrir le menu');
      document.body.classList.remove('cp-nav-open');
      if (scrim) { scrim.remove(); scrim = null; }
      burger.focus();
    };

    var openNav = function () {
      nav.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', CPT.menuClose || 'Fermer le menu');
      document.body.classList.add('cp-nav-open');
      scrim = document.createElement('button');
      scrim.className = 'cp-navscrim';
      scrim.type = 'button';
      scrim.setAttribute('aria-label', CPT.menuClose || 'Fermer le menu');
      scrim.addEventListener('click', closeNav);
      document.body.appendChild(scrim);
      var first = nav.querySelector('a');
      if (first) first.focus();
    };

    burger.addEventListener('click', function () {
      if (nav.classList.contains('is-open')) { closeNav(); } else { openNav(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
    });

    nav.addEventListener('click', function (e) {
      if (!nav.classList.contains('is-open')) return;
      if (e.target.closest('a') || e.target.closest('[data-cp-close]')) closeNav();
    });

    // Le drawer n'a plus lieu d'être si l'on repasse en desktop
    window.addEventListener('resize', function () {
      if (window.innerWidth > 989 && nav.classList.contains('is-open')) closeNav();
    });
  }

  /* --------------------------------------- Sélecteur de langue */
  /* Le sélecteur apparaît à plusieurs endroits : barre, tiroir, pied de page */
  document.querySelectorAll('[data-cp-lang]').forEach(function (sel) {
    if (!sel.form) return;
    sel.addEventListener('change', function () { sel.form.submit(); });
  });

  /* ------------------------------------------- Galerie produit
     Le défilement tactile fonctionne sans JS (scroll-snap natif).
     Ce bloc ajoute les vignettes cliquables, les flèches et le compteur. */
  document.querySelectorAll('[data-cp-gallery]').forEach(function (gal) {
    var track = gal.querySelector('[data-cp-gal-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-cp-gal-slide]'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-cp-gal-thumb]'));
    var prev = gal.querySelector('[data-cp-gal-prev]');
    var next = gal.querySelector('[data-cp-gal-next]');
    var counter = gal.querySelector('[data-cp-gal-index]');
    if (slides.length < 2) return;
    var current = 0;

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function sync() {
      // La diapositive visible est celle dont le centre est le plus proche du centre du cadre
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, dist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - track.offsetLeft + s.clientWidth / 2 - mid);
        if (d < dist) { dist = d; best = i; }
      });
      if (best === current) return;
      current = best;
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === best); });
      if (counter) counter.textContent = String(best + 1);
      if (prev) prev.disabled = best === 0;
      if (next) next.disabled = best === slides.length - 1;
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    // Flèches du clavier lorsque la galerie a le focus
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goTo(current - 1); }
      else if (e.key === 'ArrowRight') { goTo(current + 1); }
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    if (prev) prev.disabled = true;
    window.addEventListener('resize', sync);
  });

  /* ------------------------------------------- Filtres de collection
     Le formulaire fonctionne déjà sans JS (bouton « Appliquer »).
     Ici on ajoute la soumission automatique et le tiroir mobile. */
  var filterForm = document.querySelector('[data-cp-filters]');
  if (filterForm) {
    // Soumission dès qu'une case ou le tri change
    filterForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-cp-auto]')) filterForm.submit();
    });

    var filterToggle = document.querySelector('[data-cp-filter-toggle]');
    if (filterToggle) {
      var mobile = function () { return window.innerWidth <= 749; };

      var closeFilters = function () {
        filterForm.classList.remove('is-open');
        document.body.classList.remove('cp-filters-open');
        filterToggle.setAttribute('aria-expanded', 'false');
        filterToggle.focus();
      };

      var openFilters = function () {
        filterForm.classList.add('is-open');
        document.body.classList.add('cp-filters-open');
        filterToggle.setAttribute('aria-expanded', 'true');
      };

      filterToggle.addEventListener('click', function () {
        if (filterForm.classList.contains('is-open')) { closeFilters(); } else { openFilters(); }
      });

      var filterClose = filterForm.querySelector('[data-cp-filter-close]');
      if (filterClose) filterClose.addEventListener('click', closeFilters);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && filterForm.classList.contains('is-open')) closeFilters();
      });

      // Repasser en desktop doit refermer le tiroir
      window.addEventListener('resize', function () {
        if (!mobile() && filterForm.classList.contains('is-open')) closeFilters();
      });

      // Bouton « Voir les résultats », utile seulement dans le tiroir
      var done = document.createElement('button');
      done.type = 'button';
      done.className = 'cp-btn cp-btn--primary cp-filters__done';
      done.textContent = filterToggle.dataset.cpDone || 'Voir les résultats';
      done.addEventListener('click', closeFilters);
      filterForm.appendChild(done);
    }
  }

  /* ------------------------------- Prix mis à jour au choix du modèle */
  /* Initialisée au chargement ET quand Shopify recharge la section
     dans l'éditeur de thème (sinon la liste déroulante réapparaît). */
  var initProduct = function () {
    var variantSelect = document.querySelector('[data-cp-variant]');
    if (!variantSelect || variantSelect.dataset.cpInit) return;
    variantSelect.dataset.cpInit = '1';
    var vData = {};
    var vEl = document.querySelector('[data-cp-variants]');
    if (vEl) { try { vData = JSON.parse(vEl.textContent); } catch (e) { vData = {}; } }
    var priceEl = document.querySelector('[data-cp-price]');
    var compareEl = document.querySelector('[data-cp-compare]');
    var poseEl = document.querySelector('[data-cp-pose]');
    var stockEl = document.querySelector('[data-cp-stock]');
    var addBtn = document.querySelector('[data-cp-add]');
    var addLbl = document.querySelector('[data-cp-add-label]');
    var addons = Array.prototype.slice.call(document.querySelectorAll('[data-cp-addon]'));
    var picker = document.querySelector('[data-cp-picker]');
    var euro = function (n) {
      return n.toLocaleString('fr-BE', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' €';
    };
    var parseEuro = function (t) {
      var m = String(t || '').replace(/\s/g, '').replace(',', '.').match(/[\d.]+/);
      return m ? parseFloat(m[0]) : NaN;
    };

    var refresh = function () {
      var v = vData[variantSelect.value];
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) { compareEl.textContent = v.compare; compareEl.hidden = !v.compare; }
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addLbl) addLbl.textContent = v.available ? addBtn.dataset.add : addBtn.dataset.sold;
      }
      if (stockEl) {
        var sd = stockEl.dataset;
        stockEl.innerHTML = '<span class="cp-stock__dot' + (v.available ? '' : ' cp-stock__dot--out') + '"></span><strong></strong>' +
          (v.available && sd.delay ? ' · <span class="cp-stock__delay"></span>' : '');
        stockEl.querySelector('strong').textContent = v.available ? sd.in : sd.out;
        var dl = stockEl.querySelector('.cp-stock__delay');
        if (dl) dl.textContent = sd.delay;
      }
      if (poseEl) {
        var d = poseEl.dataset;
        var base = v.pose || d.productPose;
        var tpl = v.pose ? d.tplExact : d.tplFrom;
        var extra = 0;
        addons.forEach(function (a) {
          var n = parseEuro(a.dataset.pose);
          if (a.checked && !isNaN(n)) extra += n;
        });
        if (base && extra && !isNaN(parseEuro(base))) {
          poseEl.textContent = tpl.replace('[prix]', euro(parseEuro(base) + extra));
        } else if (base) {
          poseEl.textContent = tpl.replace('[prix]', /€/.test(base) ? base : euro(parseEuro(base)));
        } else {
          poseEl.textContent = d.generic;
        }
      }
    };

    /* ---- Packs en cartes (et interrupteurs Avec / Sans) : pilotent la liste */
    var groups = picker ? Array.prototype.slice.call(picker.querySelectorAll('[data-cp-opt]')) : [];
    var selectedOptions = function () {
      return groups.map(function (g) {
        if (g.hasAttribute('data-cp-toggle')) {
          if (g.hasAttribute('data-cp-forced')) return g.dataset.off;
          return g.querySelector('input').checked ? g.dataset.on : g.dataset.off;
        }
        var r = g.querySelector('input:checked');
        return r ? r.value : null;
      });
    };
    var findVariant = function (opts) {
      var found = null;
      Object.keys(vData).forEach(function (id) {
        var o = vData[id].options;
        if (opts.every(function (val, i) { return val === null || o[i] === val; })) {
          if (!found || (!vData[found].available && vData[id].available)) found = id;
        }
      });
      return found;
    };
    var syncPicker = function () {
      if (!picker) return;
      var cur = vData[variantSelect.value];
      groups.forEach(function (g, gi) {
        if (cur) {
          if (g.hasAttribute('data-cp-toggle')) {
            g.querySelector('input').checked = cur.options[gi] === g.dataset.on;
          } else {
            Array.prototype.forEach.call(g.querySelectorAll('input'), function (i) { i.checked = i.value === cur.options[gi]; });
          }
        }
      });
      var sel = selectedOptions();
      groups.forEach(function (g, gi) {
        if (g.hasAttribute('data-cp-toggle')) {
          var on = sel.slice(); on[gi] = g.dataset.on;
          var off = sel.slice(); off[gi] = g.dataset.off;
          var vOn = vData[findVariant(on)], vOff = vData[findVariant(off)];
          var delta = g.querySelector('[data-cp-delta]');
          if (delta) delta.textContent = vOn && vOff ? '+' + euro((vOn.cents - vOff.cents) / 100) : '';
          return;
        }
        Array.prototype.forEach.call(g.querySelectorAll('.cp-pack'), function (card) {
          var input = card.querySelector('input');
          var opts = sel.slice(); opts[gi] = input.value;
          var v = vData[findVariant(opts)];
          var priceSpan = card.querySelector('[data-cp-pack-price]');
          if (priceSpan) priceSpan.textContent = v ? (v.available ? v.price : (picker.dataset.sold || CPT.soldOut || 'Épuisé')) : '';
          card.classList.toggle('is-soldout', !v || !v.available);
          card.classList.toggle('is-active', input.checked);
        });
      });
    };

    variantSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantSelect.value);
      window.history.replaceState({}, '', url.toString());
      refresh();
      syncPicker();
    });
    addons.forEach(function (a) { a.addEventListener('change', refresh); });

    if (picker) {
      picker.hidden = false;
      var selWrap = variantSelect.closest('.cp-product__variants');
      if (selWrap) selWrap.classList.add('visually-hidden');
      var applyPicker = function () {
        var id = findVariant(selectedOptions());
        if (id && id !== variantSelect.value) {
          variantSelect.value = id;
          variantSelect.dispatchEvent(new Event('change'));
          return true;
        }
        return false;
      };
      // Option « caméra » masquée (remplacée par une option en plus) :
      // on bascule tout de suite sur la variante « Sans ».
      if (picker.querySelector('[data-cp-forced]')) applyPicker();
      picker.addEventListener('change', function () {
        var id = findVariant(selectedOptions());
        if (id && id !== variantSelect.value) {
          variantSelect.value = id;
          variantSelect.dispatchEvent(new Event('change'));
        } else {
          syncPicker();
        }
      });
    }
    syncPicker();
    refresh();

    /* ---- Options en plus : ajoutées au panier avec l'écran */
    var pform = variantSelect.closest('form');
    if (pform && addons.length) {
      pform.addEventListener('submit', function (e) {
        var chosen = addons.filter(function (a) { return a.checked; });
        if (!chosen.length || !window.fetch) return;
        e.preventDefault();
        var qty = parseInt((pform.querySelector('[name="quantity"]') || {}).value, 10) || 1;
        var items = [{ id: parseInt(variantSelect.value, 10), quantity: qty }].concat(chosen.map(function (a) {
          return { id: parseInt(a.dataset.cpAddon, 10), quantity: qty };
        }));
        if (addBtn) addBtn.disabled = true;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart');
          window.location.href = root + 'cart';
        }).catch(function () {
          if (addBtn) addBtn.disabled = false;
          HTMLFormElement.prototype.submit.call(pform);
        });
      });
    }
  };
  initProduct();
  document.addEventListener('shopify:section:load', initProduct);
  /* --------------------------- Sélecteur Marque → Modèle → Année */
  var finders = document.querySelectorAll('[data-cp-finder]');
  Array.prototype.forEach.call(finders, function (form) {
    var section = form.closest('section');
    var dataEl = section && section.querySelector('[data-cp-finder-data]');
    var out = section && section.querySelector('[data-cp-finder-results]');
    if (!dataEl || !out) return;
    var rows;
    try { rows = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selBrand = form.querySelector('[data-cp-finder-brand]');
    var selModel = form.querySelector('[data-cp-finder-model]');
    var selYear = form.querySelector('[data-cp-finder-year]');
    var L = out.dataset;
    var modelPh = selModel.options[0].textContent;
    var yearPh = selYear.options[0].textContent;


    var esc = function (str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };
    var fill = function (sel, placeholder, values) {
      sel.innerHTML = '';
      var first = document.createElement('option');
      first.value = ''; first.textContent = placeholder;
      sel.appendChild(first);
      values.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.value; o.textContent = v.label;
        sel.appendChild(o);
      });
      sel.disabled = values.length === 0;
    };
    var byBrand = function () {
      return rows.filter(function (r) { return r.brandKey === selBrand.value; });
    };
    var byModel = function () {
      return byBrand().filter(function (r) { return r.model === selModel.value; });
    };

    var goBtn = form.querySelector('[data-cp-finder-go]');
    var matches = function () {
      var year = parseInt(selYear.value, 10);
      var list = byModel().filter(function (r) {
        return !year || (year >= r.from && year <= r.to);
      });
      var rank = { screen: 0, kit: 1, activation: 2 };
      list.sort(function (a, b) { return (rank[a.kind] || 0) - (rank[b.kind] || 0) || a.from - b.from; });
      return list;
    };
    var reset = function () {
      out.innerHTML = '';
      if (goBtn) goBtn.disabled = !(selBrand.value && selModel.value);
    };
    var render = function (list) {
      if (!list.length) { out.innerHTML = '<p class="cp-finder__muted cp-finder__none">' + esc(L.labelNomatch) + '</p>'; return; }
      out.innerHTML = list.map(function (r) {
        var kind = r.kind === 'activation' ? L.labelKindActivation : (r.kind === 'kit' ? (L.labelKindKit || L.labelKindScreen) : L.labelKindScreen);
        var online = r.url
          ? '<p class="cp-finder__price">' + (r.price ? esc(L.labelFrom) + ' <strong>' + esc(r.price) + '</strong>' : '') + '</p>' +
            '<a class="cp-btn cp-btn--outline cp-btn--sm" href="' + esc(r.url) + '"><span>' +
            esc(r.kind === 'activation' ? L.labelActivation : (r.kind === 'kit' ? (L.labelKit || L.labelBuy) : L.labelBuy)) + '</span></a>'
          : '<p class="cp-finder__muted">' + esc(L.labelNoonline) + '</p>';
        var atelier = '<p class="cp-finder__price">' + (r.pose ? esc(L.labelFrom) + ' <strong>' + esc(r.pose) + '</strong>' : '') + '</p>' +
          '<a class="cp-btn cp-btn--primary cp-btn--sm" href="' + esc(r.book) + '"><span>' + esc(L.labelBook) + '</span></a>';
        return '<article class="cp-finder__card">' +
          '<header><p class="cp-finder__kind">' + esc(kind) + '</p>' +
          '<h3 class="cp-finder__title">' + esc(r.brand + ' ' + r.version) + '</h3>' +
          '<p class="cp-finder__years">' + r.from + '–' + r.to + '</p></header>' +
          '<div class="cp-finder__offers">' +
            '<div class="cp-finder__offer"><p class="cp-finder__label">' + esc(L.labelOnline) + '</p>' + online + '</div>' +
            '<div class="cp-finder__offer cp-finder__offer--atelier"><p class="cp-finder__label">' + esc(L.labelAtelier) + '</p>' + atelier + '</div>' +
          '</div></article>';
      }).join('');
    };

    selBrand.addEventListener('change', function () {
      var seen = {};
      var models = [];
      byBrand().forEach(function (r) {
        if (!seen[r.model]) { seen[r.model] = true; models.push({ value: r.model, label: r.model }); }
      });
      models.sort(function (a, b) { return a.label.localeCompare(b.label, undefined, { numeric: true }); });
      fill(selModel, modelPh, models);
      fill(selYear, yearPh, []);
      reset();
      if (models.length === 1) { selModel.value = models[0].value; selModel.dispatchEvent(new Event('change')); }
    });

    selModel.addEventListener('change', function () {
      var list = byModel();
      if (!list.length) { fill(selYear, yearPh, []); reset(); return; }
      var lo = Math.min.apply(null, list.map(function (r) { return r.from; }));
      var hi = Math.max.apply(null, list.map(function (r) { return r.to; }));
      var years = [];
      for (var y = hi; y >= lo; y--) years.push({ value: String(y), label: String(y) });
      fill(selYear, yearPh, years);
      reset();
    });

    selYear.addEventListener('change', reset);

    /* Un seul résultat avec une page : on y va directement.
       Plusieurs (ex. écran + activation d'origine) ou aucune page en ligne :
       on affiche le choix, avec le prix posé et le lien de réservation. */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!selBrand.value || !selModel.value) return;
      var list = matches();
      if (list.length === 1 && list[0].url) {
        window.location.href = list[0].url;
        return;
      }
      render(list);
      out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    var params = new URLSearchParams(window.location.search);
    var pre = params.get('marque');
    if (pre) {
      pre = pre.toLowerCase();
      var opt = Array.prototype.find.call(selBrand.options, function (o) { return o.value === pre; });
      if (opt) { selBrand.value = pre; selBrand.dispatchEvent(new Event('change')); }
    }
  });
  /* ------------------------------------- Centre d'aide FAQ : recherche */
  var faqInput = document.querySelector('[data-cp-faq-q]');
  var faqItems = Array.prototype.slice.call(document.querySelectorAll('[data-cp-faq-item]'));
  if (faqItems.length) {
    var norm = function (t) {
      return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    };
    var chipsBox = document.querySelector('[data-cp-faq-chips]');
    var countEl = document.querySelector('[data-cp-faq-count]');
    var emptyEl = document.querySelector('[data-cp-faq-empty]');
    var activeCat = '';
    faqItems.forEach(function (it) { it._txt = norm(it.textContent); });

    if (chipsBox) {
      var cats = [];
      faqItems.forEach(function (it) { var c = it.dataset.cat; if (c && cats.indexOf(c) < 0) cats.push(c); });
      [''].concat(cats).forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cp-faqhub__chip' + (c === '' ? ' is-active' : '');
        b.textContent = c || chipsBox.dataset.all || 'Tout';
        b.addEventListener('click', function () {
          activeCat = c;
          Array.prototype.forEach.call(chipsBox.children, function (x) { x.classList.toggle('is-active', x === b); });
          filterFaq();
        });
        chipsBox.appendChild(b);
      });
    }

    var filterFaq = function () {
      var words = norm(faqInput ? faqInput.value : '').split(/\s+/).filter(Boolean);
      var shown = 0;
      faqItems.forEach(function (it) {
        var ok = (!activeCat || it.dataset.cat === activeCat) &&
          words.every(function (w) { return it._txt.indexOf(w) > -1; });
        it.hidden = !ok;
        if (ok) shown++;
        if (!ok) it.open = false;
      });
      if (words.length && shown > 0 && shown <= 2) {
        faqItems.forEach(function (it) { if (!it.hidden) it.open = true; });
      }
      if (countEl) {
        countEl.textContent = (words.length || activeCat) ? shown + ' ' + (shown > 1 ? (CPT.answers || 'réponses') : (CPT.answer || 'réponse')) : '';
      }
      if (emptyEl) emptyEl.hidden = shown !== 0;
    };
    if (faqInput) {
      faqInput.addEventListener('input', filterFaq);
      var qp = new URLSearchParams(window.location.search).get('q');
      if (qp) { faqInput.value = qp; filterFaq(); }
    }
  }
})();

/* Vidéo YouTube / Vimeo : chargée seulement au clic (site plus rapide) */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-cp-video-src]');
  if (!b) return;
  var src = b.getAttribute('data-cp-video-src');
  if (!src) return;
  var f = document.createElement('iframe');
  f.src = src;
  f.title = b.getAttribute('aria-label') || CPT.video || 'Vidéo';
  f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
  f.allowFullscreen = true;
  b.replaceWith(f);
});
/* Vidéos courtes de la galerie : ne tournent que lorsqu'elles sont visibles */
(function () {
  var vids = document.querySelectorAll('.cp-shot__vid');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else { v.pause(); }
    });
  }, { rootMargin: '200px' });
  vids.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); io.observe(v); });
})();

/* Langue autre que le français : les liens internes écrits en dur dans le
   contenu (« /pages/contact », « /collections/… ») gardent le préfixe de
   langue (« /nl/… »), sinon le visiteur retombe sur la version française. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root === '/') return;
  var fix = function (scope) {
    (scope || document).querySelectorAll('a[href^="/"]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (h.indexOf('//') === 0 || h.indexOf(root) === 0 || h === root.slice(0, -1)) return;
      if (/^\/(cdn|checkouts?|services|apps|account\/logout)(\/|$)/.test(h)) return;
      a.setAttribute('href', root + h.slice(1));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fix(); });
  else fix();
  document.addEventListener('shopify:section:load', function (e) { fix(e.target); });
})();
